'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _actionToReducerMap;

exports.default = reducer;

var _immutable = require('immutable');

var _constants = require('./constants');

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Action to open modal was called
 * @param {Map} state The state
 * @param {Object} action The action triggering the update
 * @returns {Map} The new state
 */
var openModal = function openModal(state, action) {
    if ((0, _actions.isOpenModalAction)(action)) {
        return state.set('activeModalName', action.activeModalName);
    }
    return state;
};

/**
 * Action to close modal was called
 * @param {Map} state The state
 * @param {Object} action The action triggering the update
 * @returns {Map} The new state
 */
var closeModal = function closeModal(state, action) {
    if ((0, _actions.isCloseModalAction)(action)) {
        return state.set('activeModalName', '');
    }
    return state;
};

/**
 * A map from action types to reducers
 * @type {ActionToReducerMapType}
 */
var actionToReducerMap = (_actionToReducerMap = {}, (0, _defineProperty3.default)(_actionToReducerMap, _constants.OPEN_MODAL, openModal), (0, _defineProperty3.default)(_actionToReducerMap, _constants.CLOSE_MODAL, closeModal), _actionToReducerMap);

var initialState = (0, _immutable.Map)({
    activeModalName: ''
});

/**
 * Modal component reducer.
 * @param {Map} state The application state
 * @param {Object} action The action dispatched
 * @returns {Map} The resulting state
 */
function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (actionToReducerMap[action.type]) {
        return actionToReducerMap[action.type](state, action);
    }

    return state;
}
//# sourceMappingURL=reducer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/modal-component/dist/main/reducer.js
// module id = 507
// module chunks = 0